import { ColDef } from "ag-grid-community";
import { ReportsTableData } from "../../../../../../../../store/reports/utils/types/types";

export const reportsSourceSortingFn: ColDef<ReportsTableData>["comparator"] = (
  valueA,
  valueB,
  nodeA,
  nodeB,
) => {
  const currentRow = nodeA?.data;
  const nextRow = nodeB?.data;

  const current = (
    currentRow?.sourceName ??
    currentRow?.source_id ??
    ""
  ).toLowerCase();
  const next = (nextRow?.sourceName ?? nextRow?.source_id ?? "").toLowerCase();

  return current.localeCompare(next);
};
